import React, { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { PortalDialog } from '@component/Portal';
import { BasicAlertDialog } from '@component/Dialog/BasicAlertDialog';
import { useMediaMobile } from '@app/react/common/useMedia';
import { useHistoryGoParts } from '@app/react/contexts/useHistoryGoParts';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import { isDisableFeatherinside } from '@app/react/common/isDisableFeatherinside';
import type { AppState } from '@app/react/reducer';
import { MAKIWARA, PartsProduct } from '@app/react/const/type';

const title = '「羽根」が選択されていないため羽中加工を選択することができません。';
const desktop = {
    description: '羽中加工を施すには、羽根を選択し直してください。',
    btnName: '羽根の選択へ →',
};
const mobile = {
    description: 'カスタマイズ画面に戻って羽根を選択し直してください。',
    btnName: '戻る',
};

const selectFeather = (state: AppState): PartsProduct | null => state.customize.feather;

export const FeatherinsideCantSelectDialogContainer: FC = () => {
    const isMobile = useMediaMobile();
    const goParts = useHistoryGoParts();
    const { arrowType } = useOrderPathParams();

    const feather = useSelector(selectFeather);
    const opts = feather?.options ?? {};
    const disableFeatherinside = feather === null || isDisableFeatherinside(opts);

    const [hidden, setHidden] = useState(!disableFeatherinside);
    const className = classNames('layout-right', { hidden });

    const handleGoBackFeather = useCallback(() => {
        goParts('hane');
    }, [goParts]);

    const handleGoBack = useCallback(() => {
        setHidden(true);
        goParts('preview');
    }, [goParts, setHidden]);

    if (arrowType !== MAKIWARA) {
        return null;
    }

    if (isMobile) {
        return (
            <PortalDialog>
                <BasicAlertDialog
                    className={className}
                    title={title}
                    description={mobile.description}
                    btnName={mobile.btnName}
                    onClick={handleGoBack}
                />
            </PortalDialog>
        );
    }

    return (
        <BasicAlertDialog
            className={className}
            title={title}
            description={desktop.description}
            btnName={desktop.btnName}
            onClick={handleGoBackFeather}
        />
    );
};
